<template>

  <div :id="_uid" class="ui small modal" :class="modalSelector">
    <div class="ui header">
      {{ isCreating ? "Novo Tipo de Serviço" : "Alterar Tipo de Serviço" }}
    </div>
    <div class="content">
      <div class="ui form">
        <div class="fields">
          <div class="sixteen wide field">
            <label class="form-label">Descrição <span class="red text">*</span></label>
            <input class="uppercase" v-model="type.description" @blur="type.description = $toUpperCase($event)">
          </div>     
        </div>  
        <div class="fields">
          <div class="eight wide field">
            <label class="form-label">Ícone <span class="red text">*</span></label>
            <select-dropdown ref="iconDropdown" @onChange="onChangeIcon" />
          </div>
          <div class="eight wide field">
            <label class="form-label">% Colaborador</label>
            <input class="money" :value="employeeFee" @blur="employeeFee = $event.target.value">
          </div>
        </div>      
      </div>
    </div>
    <div class="actions">
      <button class="ui cancel basic button">
        <i class="times icon"></i>
        Cancelar
      </button>            
      <button class="ui blue button" @click="onConfirm()">
        <i class="checkmark icon"></i>
        {{ isCreating ? "Confirmar" : "Atualizar" }}
      </button>
    </div>
  </div>  

</template>

<script>

  import modalDialog from "@/mixins/modal-dialog"
  import Input from "@/utils/input"
  import SelectDropdown from "@/components/select-dropdown"
  import SrvService from "@/services/srv-service"

  export default {

    name: "ServiceTypeFormModal",

    mixins: [modalDialog],
    
    data() {
      return {
        type: {},
      }
    },

    components: {
      SelectDropdown,
    },

    mounted() {
      Input.maskFloat()
    },

    computed: {

      employeeFee: {
        get() {
          return Input.floatToString(this.type.employeeFee)
        },
        set(value) {
          this.type.employeeFee = Input.stringToFloat(value)    
        },
      },
    },

    methods: {

      refreshData() {
        this.type = this.$cloneObject(this.type)
      },

      load(type) {

        this.type = {}

        if (type)
          this.type = this.$cloneObject(type)

        this.loadIconDropdown()  

        this.show()
      },

      loadIconDropdown() {

        let typeList = []
        const TYPE_ICONS = SrvService.TYPE_ICONS

        for (let prop in TYPE_ICONS) {
          if (TYPE_ICONS.hasOwnProperty(prop)) {
            typeList.push({
              id: prop,
              value: `<i class="${TYPE_ICONS[prop].icon}"></i> ` + TYPE_ICONS[prop].description
            })
          }
        }

        this.$refs.iconDropdown.setValues(typeList, this.type.icon)
      },

      onChangeIcon(icon) {
        this.type.icon = icon
        this.refreshData()
      },

      onConfirm() {

        if (!this.validData())
          return

        const event = this.isCreating ? "onCreate" : "onUpdate"

        this.emit(event, this.$cloneObject(this.type))
      },

      validData() {

        let isOk = true
        let message = ""

        if (!this.type.description) {
          message = "Informe a descrição do tipo de serviço"
        } else if (!this.type.employeeFee) {
          message = "Informe o percentual dos colaboradores"  
        } else if (!this.type.icon) {
          message = "Informe o ícone do tipo de serviço"
        }  

        if (message) {
          isOk = false
          this.$msg.info(message)
        }

        return isOk
      },
    },
  }

</script>